export const RETAILER_ORDERS_ORDER = '[retailer-orders] order';
export const RETAILER_ORDERS_MODAL = '[retailer-orders] modal';
export const RETAILER_ORDERS_CLOSE_MODAL = '[retailer-orders] close-modal';
